const style = (theme) => {
  const sectionsHeight = '100vh'

  const output = {
    root: {
      position: 'relative',
      zIndex: 1,
      color: theme.colors[3],
    },
    page: {},
    wrapper: {
      extend: theme.smallWrapper,
    },
    overview: {
      position: 'absolute',
      top: 0,
      zIndex: 1,
      '& > *': {
        position: 'absolute',
        top: 0,
        zIndex: 1,
      },
    },
    pageScrollOverview: {
      display: 'flex',
      flexDirection: 'column',
      height: sectionsHeight,
      touchAction: 'none',
    },
    backgroundBlue: {
      backgroundColor: theme.colors[9],
      color: theme.colors[1],
      display: 'flex',
      flexDirection: 'column',
    },
    backgroundLight: {
      backgroundColor: theme.colors[6],
      color: theme.colors[3],
      overflow: 'hidden',
    },
    description: {},
    section: {
      paddingTop: 200,
      paddingBottom: 200,
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
    },
    gallery: {
      extend: theme.smallWrapper,
      paddingTop: 10,
      paddingBottom: 10,
      width: '100vw',
      height: '100%',
      '& .slick-list': {
        width: '65%',
        margin: '0 auto',
        overflow: 'hidden',
      },
      '& .slick-arrow': {
        zIndex: 1,
        backgroundColor: theme.colors[1],
        '& svg': {
          fill: theme.colors[3],
        },
      },
      '& .slick-prev': {
        left: 25,
      },
      '& .slick-next': {
        right: 25,
      },
      '& .Carousel__carouselItem': {
        padding: 10,
      },
      '& .Carousel__carouselImg': {
        position: 'relative',
        zIndex: 1,
        paddingBottom: '62.5%',
        boxShadow: `0px 0px 10px 1px ${theme.getRgba(theme.colors[0], 0.3)}`,
        overflow: 'hidden',
        borderRadius: 20,
        '& img': {
          width: '100%',
          height: '110%',
          objectFit: 'cover',
        },
      },
      '& .Carousel__carouselItemVertical': {
        '& .Carousel__carouselImg': {
          width: '50%',
          height: '100%',
          marginLeft: 'auto',
          marginRight: 'auto',
        },
      },
    },
    bottomPage: {
      display: 'flex',
      justifyContent: 'center',
      textAlign: 'center',
      fontSize: 16,
      color: theme.colors[3],
      fontWeight: 400,
      minHeight: 'auto',
      '& h5': {
        fontFamily: theme.fonts[1],
        fontSize: 40,
        color: theme.colors[4],
        fontWeight: 100,
        lineHeight: 1,
        margin: '0 0 20px 0',
      },
      '& a': {
        marginTop: 50,
      },
    },
    footer: {
      marginTop: '0 !important',
    },
    overviewFooter: {
      extend: theme.smallWrapper,
      position: 'absolute',
      zIndex: 1,
      top: 0,
      left: 0,
      width: '100%',
      display: 'flex',
      justifyContent: 'flex-end',
      alignItems: 'flex-end',
      height: 'calc(var(--vh) - 100px)',
      pointerEvents: 'none',
    },
    scrollDown: {
      pointerEvents: 'all',
    },
    hide: {
      pointerEvents: 'none',
    },
  }

  /*------------------------------
  MD
  ------------------------------*/
  output[theme.mediaInverse.md] = {
    section: {
      paddingTop: 100,
      paddingBottom: 100,
    },
  }

  /*------------------------------
  SM
  ------------------------------*/
  output[theme.mediaInverse.sm] = {
    section: {
      paddingTop: 50,
      paddingBottom: 50,
      minHeight: 'auto',
    },
    backgroundBlue: {
      marginTop: 0,
    },
    gallery: {
      paddingLeft: 0,
      paddingRight: 0,
      '& .slick-list': {
        width: '100%',
      },
      '& .Carousel__carouselItem': {
        padding: 0,
      },
      '& .Carousel__carouselImg': {
        borderRadius: 0,
      },
      '& .slick-dots': {
        display: 'none !important',
      },
      '& .slick-arrow': {
        transform: 'none',
        bottom: -60,
        top: 'unset',
      },
      '& .slick-prev': {
        left: '100px !important',
      },
      '& .slick-next': {
        right: '100px !important',
      },
    },
    overviewFooter: {
      height: 'calc(var(--vh-fixed) - 100px)',
    },
  }

  return output
}

export default style
